<script>
  export let title = '';
  export let columns = [];
  export let data = [];
  export let showViewAll = false;
</script>

<div class="bg-white rounded-lg border border-gray-200 p-6">
  <div class="flex items-center justify-between mb-4">
    <h3 class="text-lg font-semibold text-gray-900">{title}</h3>
    {#if showViewAll}
      <button class="text-sm text-blue-600 hover:text-blue-700">View all</button>
    {/if}
  </div>

  <div class="overflow-x-auto">
    <table class="w-full">
      <thead>
        <tr class="border-b border-gray-200">
          {#each columns as column}
            <th class="text-left py-3 px-4 text-xs font-medium text-gray-500 uppercase tracking-wider">
              {column.label}
            </th>
          {/each}
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        {#each data as row, idx}
          <tr class="hover:bg-gray-50">
            {#each columns as column}
              <td class="py-3 px-4 text-sm text-gray-900">
                {#if column.render}
                  {@html column.render(row[column.key], row, idx)}
                {:else}
                  {row[column.key]}
                {/if}
              </td>
            {/each}
          </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>
